<template>
<div>
  <b-card
    class="light-style"
    footer-tag="footer"
  >
    <b-form>
      <b-form-group label="ORCID">
        <b-input
          type="text"
          v-model="update_orcid_form.orcid"
          placeholder="ORCID"
          autocomplete="off"
          data-lpignore="true"
          :class="{
            'is-invalid': !isValid,
            'is-valid': isValid,
          }"
        />
      </b-form-group>
      <div v-if="!isValid" class="v-error">Invalid ORCID format / ORCID is required</div>
    </b-form>
    <template #footer>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="danger"
          :disabled="loading"
          @click="close()"
          class="mr-2"
        >
          <b-spinner v-if="loading" />
          CLOSE
        </b-button>
        <b-button
          variant="success"
          class="submit-btn"
          :disabled="loading"
          type="submit"
          @click="onSubmit($event)"
        >
          <b-spinner v-if="loading" />
          UPDATE
        </b-button>
      </div>
    </template>
  </b-card>
</div>
</template>

<script>
export default {
  name: 'UpdateORCIDFormSection',
  props: ['personData', 'accessByAdmin'],
  data () {
    return {
      update_orcid_form: {
        orcid: ""
      },
      loading: false
    }
  },
  created() {
    this.update_orcid_form.orcid = this.personData.orcid_id
  },
  computed: {
    isValid() {
      if(this.accessByAdmin === 'false') {
        const customRegex = /^(\d{4}-\d{4}-\d{4}-\d{3}[0-9X])$/;
        return customRegex.test(this.update_orcid_form.orcid);
      } else {
        return true;
      }
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (!this.isValid) {
        this.$toasted.global.error('Please fill out the required fields.')
      } else{
        this.updateORCID()
      }
    },
    async updateORCID() {
      this.loading = true;
      const params = {
        "id": this.personData.person_id,
        "orcid": this.update_orcid_form.orcid
      }
      const response = await this.$http.post(process.env.VUE_APP_API_URL + '/people/update_orcid', params)
      if (response !== undefined) {
        this.$toasted.global.success("Updated Successfully")
        this.loading = false;
        this.$emit('updateORCIDData', false)
      } else {
        this.loading = false;
      }
    },
    close() {
      this.$emit('updateORCIDData', true)
    }
  }
}
</script>
